<div class="modal-header">

  <h4 class="modal-title">{{ alarm?.alarmDevice.iotRegister.measuringPoint['name' + crtLang.toUpperCase()] }}</h4>

  <button type="button" class="btn-close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

@if (alarm) {
  <div class="modal-body">
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li ngbNavItem="form">
        <a ngbNavLink>{{ 'alarms.management.detail.section.information' | translate }}</a>
        <ng-template ngbNavContent>
          <div class="row">
            <!-- Left Panel -->
            <div class="col-12 col-sm-6">
              <h4 class="mt-2">{{ 'alarms.management.detail.section.alarm' | translate }}</h4>
              <!-- Classification -->
              <div class="col-12">
                <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.classification' | translate }}</label>
                <p>{{ ('common.alarmClassification.' + alarm.alarmDevice.classification) | translate }}</p>
              </div>
              <!-- Appeared Date -->
              <div class="col-12">
                <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.appearedDate' | translate }}</label>
                <p>{{ alarm.appearedDateTime | date: dateTimeFormat }}</p>
              </div>
              <!-- AlarmState -->
              <div class="col-12">
                <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.alarmState' | translate }}</label>
                <p>
                  <span class="dot white-border"
                    [class.red]="alarm.alarmState === AlarmState.Active"
                    [class.yellow]="alarm.alarmState === AlarmState.InProgress"
                  [class.green]="alarm.alarmState === AlarmState.Solved"></span>
                  {{ 'common.alarmState.' + alarm.alarmState | translate }}
                </p>
              </div>
              <!-- Alarm Code -->
              @if (alarm.code) {
                <div class="col-12">
                  <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.code' | translate }}</label>
                  <p>{{ alarm.code }}</p>
                </div>
              }
              <!-- Alarm Description -->
              @if (alarm.description) {
                <div class="col-12">
                  <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.description' | translate }}</label>
                  <pre>{{ alarm.description }}</pre>
                </div>
              }
              <!-- Alarm Value -->
              @if (alarm.value) {
                <div class="col-12">
                  <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.value' | translate }}</label>
                  <p>{{ alarm.value }}</p>
                </div>
              }
            </div>
            <!-- Right Panel -->
            <div class="col-12 col-sm-6">
              <h4 class="mt-2">{{ 'alarms.management.detail.section.device' | translate }}</h4>
              <!-- Equipment -->
              <div class="col-12">
                <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.equipment' | translate }}</label>
                <p>{{ alarm.alarmDevice.iotRegister.measuringPoint['name' + crtLang.toUpperCase()] }}</p>
              </div>
              <!-- Designation -->
              <div class="col-12">
                <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.designation' | translate }}</label>
                <p>{{ alarm.alarmDevice.iotRegister['label' + crtLang.toUpperCase()] }}</p>
              </div>
              <!-- Location -->
              <div class="col-12">
                <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.location' | translate }}</label>
                <p>{{ alarm.alarmDevice.location }}</p>
              </div>
              <!-- Comment -->
              <div class="col-12">
                <label class="form-label mb-0" for="">{{ 'alarms.management.detail.label.comment' | translate }}</label>
                <pre disabled>{{ alarm.alarmDevice.comment }}</pre>
              </div>
            </div>
          </div>
          <div class="btn-bar">
            @if (alarm.alarmState === AlarmState.Active) {
              <button class="btn btn-primary"
                (click)="setAlarmInProgress(alarm)"
                title="{{ 'common.tooltip.inProgress' | translate }}">
                <fa-icon [icon]="icons.inProgress"></fa-icon>
                <span> {{ 'alarms.management.detail.button.setInProgress' | translate }}</span>
              </button>
            }
            @if (alarm.alarmState !== AlarmState.Solved) {
              <button class="btn btn-primary"
                (click)="releaseAlarm(alarm)"
                title="{{ 'common.tooltip.release' | translate }}">
                <fa-icon [icon]="icons.release"></fa-icon>
                <span> {{ 'alarms.management.detail.button.release' | translate }}</span>
              </button>
            }
          </div>
        </ng-template>
      </li>
      @if (alarm.alarmEvents.length > 0) {
        <li ngbNavItem="events">
          <a ngbNavLink>{{ 'alarms.management.detail.section.events' | translate }}</a>
          <ng-template ngbNavContent>
            <h4 class="mt-2">{{ 'alarms.management.detail.section.events' | translate }}</h4>
            <!-- Alarm Events Table-->
            <div class="table-responsive mt-4 table-wrapper-scroll-y">
              <table class="table table-striped"
                [attr.aria-label]="'alarms.management.detail.section.events' | translate">
                <thead>
                  <tr>
                    <th scope="col" style="width: 175px;" translate="alarms.management.detail.events.dateTime"></th>
                    <th scope="col" translate="alarms.management.detail.events.event"></th>
                    <th scope="col" style="width: 175px;" translate="alarms.management.detail.events.user"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (event of alarm.alarmEvents; track event) {
                    <tr>
                      <td>{{ event.dateTime | date: dateTimeFormat }}</td>
                      <td>{{ ('common.alarmEventType.' + event.alarmEventType) | translate : {ContactName: event.contactName} }}</td>
                      <td>
                        @if (event.backoffice) {
                          <span>{{ event.backoffice.firstName + ' ' + event.backoffice.lastName }}</span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </ng-template>
        </li>
      }
      @if (alarm.technicalEvents.length > 0) {
        <li ngbNavItem="technicalEvents">
          <a ngbNavLink>{{ 'alarms.management.detail.section.technicalEvents' | translate }}</a>
          <ng-template ngbNavContent>
            <h4 class="mt-2">{{ 'alarms.management.detail.section.technicalEvents' | translate }}</h4>
            <!-- Alarm Technical Events Table-->
            <div class="table-responsive mt-4 table-wrapper-scroll-y">
              <table class="table table-striped"
                [attr.aria-label]="'alarms.management.detail.section.technicalEvents' | translate">
                <thead>
                  <tr>
                    <th scope="col" translate="alarms.management.detail.technicalEvents.creationDateTime"></th>
                    <th scope="col" translate="alarms.management.detail.technicalEvents.originatorComponent"></th>
                    <th scope="col" translate="alarms.management.detail.technicalEvents.technicalCode"></th>
                    <th scope="col" translate="alarms.management.detail.technicalEvents.description"></th>
                    <th scope="col" translate="alarms.management.detail.technicalEvents.sourceEventId"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (event of alarm.technicalEvents; track event) {
                    <tr>
                      <td>{{ event.creationDateTime | date: dateTimeFormat }}</td>
                      <td>{{ event.originatorComponentName ?? event.originatorComponentId }}</td>
                      <td>{{ event.technicalCode }}</td>
                      <td>{{ event.description }}</td>
                      <td>{{ event.sourceEventId }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </ng-template>
        </li>
      }
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
}

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary"
    (click)="activeModal.close()"
    translate="common.close">
  </button>
</div>
